const o = {
  primary: {
    color: "primary"
  },
  secondary: {
    color: "secondaryText"
  },
  article: {
    color: "accent",
    "&:visited": {
      color: "black"
    }
  }
}, c = {
  links: o
};
export {
  c as linksTheme
};
